module.exports = __webpack_public_path__ + "img/worked_hours.395525c8.svg";